

export default {
  props: {
    color: {type: String, default: 'var(--gray-600)'},
    size: {type: String, default: '2rem'},
    exts: {type: Array, default: () => ['pdf', 'docx']},
    disabled: {type: Boolean, default: false},
  },
  emits: ['save'],
  data(){
    return {
      visible: false
    }
  },

  methods: {
    save(ext, hide) {
      this.$emit('save', ext)
      hide()
    }
  }
}
